// Merkezi input doğrulama ve TR sayı formatlama yardımcıları.
// Amaç: Kullanıcı hiçbir zaman geçersiz karakter tuşlayamasın, sayı alanları
// her zaman rakam + tek ondalık ayırıcı ile sınırlı olsun.

/**
 * Ondalık sayı sanitizer'ı — harf, boşluk, çoklu ayırıcı, negatif işareti temizler.
 * Kabul: rakamlar + tek nokta VEYA tek virgül (ilkine öncelik verilir).
 *
 * @param {string} value
 * @param {{ maxDecimals?: number }} opts
 */
export function sanitizeDecimal(value, opts = {}) {
  const { maxDecimals = 4 } = opts;
  if (value == null) return "";
  let s = String(value).replace(/[^\d.,]/g, "");
  const firstSep = s.search(/[.,]/);
  if (firstSep !== -1) {
    const sep = s[firstSep];
    s = s.slice(0, firstSep + 1) + s.slice(firstSep + 1).replace(/[.,]/g, "");
    if (maxDecimals >= 0) {
      const idx = s.indexOf(sep);
      s = s.slice(0, idx + 1) + s.slice(idx + 1, idx + 1 + maxDecimals);
    }
  }
  return s;
}

/** Yalnızca rakam bırakır (adet, kod vb.). */
export function sanitizeInteger(value) {
  if (value == null) return "";
  return String(value).replace(/\D/g, "");
}

/**
 * TR telefon zırhı: yalnızca rakam bırakır, ülke kodu (+90) ve baştaki 0'ı
 * temizler, en fazla 10 hane döndürür. Kullanıcı "0532...", "+90 532..." veya
 * "532..." nasıl yazarsa yazsın normalize eder.
 */
export function sanitizePhone(value) {
  if (value == null) return "";
  let s = String(value).replace(/\D/g, "");
  if (s.startsWith("90") && s.length > 10) s = s.slice(2);
  if (s.startsWith("0")) s = s.slice(1);
  return s.slice(0, 10);
}

/** Görsel biçim: "532 123 45 67". */
export function formatPhoneTR(value) {
  const s = sanitizePhone(value);
  if (!s) return "";
  const p = [s.slice(0, 3), s.slice(3, 6), s.slice(6, 8), s.slice(8, 10)].filter(Boolean);
  return p.join(" ");
}

/**
 * Geçerli TR telefon: 10 hane, ilk hane 2-5 arası (2/3/4 sabit hat, 5 mobil).
 * 10 haneden az veya harf/boşluk içeriyorsa false.
 */
export function isValidTurkishPhone(value) {
  const s = sanitizePhone(value);
  if (s.length !== 10) return false;
  return /^[2-5]/.test(s);
}

/**
 * TR sayı parse: "1.250,50" → 1250.5 · "1250.50" → 1250.5 · "1,5" → 1.5
 * Hem TR (1.250,50) hem EN (1,250.50) formatını akıllıca çözer.
 */
export function parseTRNumber(str) {
  if (str == null || str === "") return 0;
  let s = String(str).trim().replace(/\s/g, "");
  if (s.includes(",") && s.includes(".")) {
    // Son ayırıcı ondalıktır (kullanıcı intent'i)
    const lastComma = s.lastIndexOf(",");
    const lastDot = s.lastIndexOf(".");
    if (lastComma > lastDot) {
      s = s.replace(/\./g, "").replace(",", ".");
    } else {
      s = s.replace(/,/g, "");
    }
  } else if (s.includes(",")) {
    s = s.replace(",", ".");
  }
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}

/** TR biçimli sayı: 1.250,50 */
export function fmtTR(n, dec = 2) {
  const num = typeof n === "number" ? n : Number(n) || 0;
  return num.toLocaleString("tr-TR", { minimumFractionDigits: dec, maximumFractionDigits: dec });
}

/** TR biçimli TL: 1.250,50 ₺ */
export function fmtTL(n, dec = 2) {
  return `${fmtTR(n, dec)} ₺`;
}

/** TR biçimli gram: 1,7500 gr */
export function fmtGr(n, dec = 4) {
  return `${fmtTR(n, dec)} gr`;
}
